// extracted by mini-css-extract-plugin
module.exports = {"bidLayout":"bids_bidLayout__0KjDP","card":"bids_card__FYBd3","innerContent":"bids_innerContent__eXarg","imgContainer":"bids_imgContainer__wSRbE","tray":"bids_tray__XM82u"};